import React, { useEffect, useRef, useState } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import { MdOutlineNewReleases } from "react-icons/md";
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import Drp_Projects from '../../Components/Project/Drp_Projects';
import VersionProp from '../../Components/ProjectVersion/VersionProp';
import ResponsiveList, { CardTitle, CardField, CardActions } from '../../Components/Shared/ResponsiveList';
import RowHeight from '../../Components/Shared/RowHeight';

const { Column, HeaderCell, Cell } = Table;

const Index = () => {

    //#region Const

    let navigate = useNavigate();
    const VersionRef = useRef();
    const ProjectRef = useRef();

    const [showDrawer, setShowDrawer] = useState(false);
    const [ShowLoading, setShowLoading] = useState(false);
    const [Data, setData] = useState([]);
    const [ProjectId, setProjectId] = useState(General.GuidEmpty());
    const [DeleteId, setDeleteId] = useState(General.GuidEmpty());
    const [ShowDelete, setShowDelete] = useState(false);
    //#endregion

    //#region Methods

    const Bind = (projectId) => {
        if (!projectId || projectId === General.GuidEmpty()) {
            setData([]);
            return;
        }
        setShowLoading(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/ProjectVersion/GetByProjectId",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "ProjectId": projectId
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setData(res.data);
                setShowLoading(false);
            })
            .catch(error => {
                setShowLoading(false);
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    const SelectProject = (value) => {
        setProjectId(value);
        Bind(value);
    }

    const handleVersionProp = (Id) => {
        if (ProjectId === General.GuidEmpty()) {
            General.ShowMsg(Enum.MsgType.error, "ابتدا پروژه را انتخاب نمایید");
            return;
        }
        setShowDrawer(true);
        setTimeout(() => {
            VersionRef.current.ShowEdit(Id);
        }, 500);
    };

    const AskDelete = (Id) => {
        setDeleteId(Id);
        setShowDelete(true);
    }

    const DoDelete = () => {
        var RequestOption = {
            method: "Post",
            url: General.ApiRoute() + "/ProjectVersion/Delete",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: DeleteId
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setShowDelete(false);
                if (res.data.isSuccess) {
                    General.ShowMsg(Enum.MsgType.success, General.DeleteSuccess());
                    Bind(ProjectId);
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.DeleteError() + res.data.error);
                }
            })
            .catch(error => {
                setShowDelete(false);
                General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
            })
    }

    useEffect(() => {
        ProjectRef.current.Get();
    }, [])
    //#endregion

    return (
        <Shared pageTitle={<><MdOutlineNewReleases size={25} /> قابلیت های هر نسخه</>}>

            <rsuite.Row>
                <rsuite.Col xs={24} md={10}>
                    <label>پروژه</label>
                    <Drp_Projects ref={ProjectRef} value={ProjectId} onSelect={SelectProject} />
                </rsuite.Col>
            </rsuite.Row>

            <div align="left">
                <rsuite.Button appearance="primary" className="mb-2 ms-2"
                    onClick={() => handleVersionProp(General.GuidEmpty())}>
                    ثبت نسخه جدید
                </rsuite.Button>
            </div>
            <rsuite.Divider />

            {
                ProjectId === General.GuidEmpty() ?
                    <div style={{ padding: 24, textAlign: 'center', color: '#8c97a3' }}>
                        برای دیدن نسخه ها، ابتدا پروژه را انتخاب کنید
                    </div>
                    :
                    <ResponsiveList
                fillHeight
                        data={Data}
                        loading={ShowLoading}
                        emptyText="برای این پروژه نسخه ای ثبت نشده است"
                        filters={[
                            { key: 'version', label: 'نسخه', type: 'text' },
                            { key: 'releaseDate', label: 'تاریخ انتشار', type: 'text' }
                        ]}
                        renderCard={(rowData) => (
                            <>
                                <CardTitle>نسخه {rowData.version}</CardTitle>
                                <CardField label="تاریخ انتشار">{rowData.releaseDate}</CardField>
                                <CardField label="تعداد قابلیت">{rowData.featureCount}</CardField>
                                <CardActions>
                                    <rsuite.Button size="sm"
                                        onClick={() => handleVersionProp(rowData.id)}>ویرایش</rsuite.Button>
                                    <rsuite.Button size="sm" appearance="primary" color="red"
                                        onClick={() => AskDelete(rowData.id)}>حذف</rsuite.Button>
                                </CardActions>
                            </>
                        )}
                    >
                        <Table
                            rtl={true}
                            className='w-100'
                            bordered
                            headerHeight={40}
                            rowHeight={RowHeight}
                    wordWrap="break-word"
                            data={Data}
                            loading={ShowLoading}
                        >
                            <Column>
                                <HeaderCell><b>ردیف</b></HeaderCell>
                                <General.RowNumber />
                            </Column>
                            <Column flexGrow={2}>
                                <HeaderCell><b>نسخه</b></HeaderCell>
                                <Cell dataKey="version" />
                            </Column>
                            <Column flexGrow={2}>
                                <HeaderCell><b>تاریخ انتشار</b></HeaderCell>
                                <Cell dataKey="releaseDate" />
                            </Column>
                            <Column flexGrow={1}>
                                <HeaderCell><b>تعداد قابلیت</b></HeaderCell>
                                <Cell dataKey="featureCount" />
                            </Column>
                            <Column fixed="right" flexGrow={2}>
                                <HeaderCell>عملیات</HeaderCell>
                                <Cell>
                                    {rowData => (
                                        <>
                                            <rsuite.Button size="xs"
                                                onClick={() => handleVersionProp(rowData.id)}>ویرایش</rsuite.Button>
                                            <rsuite.Button size="xs" appearance="primary" color="red" className='ms-2'
                                                onClick={() => AskDelete(rowData.id)}>حذف</rsuite.Button>
                                        </>
                                    )}
                                </Cell>
                            </Column>
                        </Table>
                    </ResponsiveList>
            }

            <rsuite.Drawer
                open={showDrawer}
                onClose={() => setShowDrawer(false)}
                placement={isMobile ? 'bottom' : 'right'}
                size={isMobile ? 'full' : 'sm'}
            >
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>مشخصات نسخه</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <VersionProp
                        ref={VersionRef}
                        projectId={ProjectId}
                        onSubmit={() => { setShowDrawer(false); Bind(ProjectId); }}
                    />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

            {/* حذف نسخه از الگوی Delete مشترک استفاده نمی کند چون آن کامپوننت
                شناسه را در هدر می فرستد و برای هر موجودیت یک DeleteType لازم
                دارد؛ اینجا یک تایید ساده کافی است */}
            <rsuite.Modal open={ShowDelete} onClose={() => setShowDelete(false)} size="xs">
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title>حذف نسخه</rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    با حذف نسخه، همه قابلیت های ثبت شده برای آن هم حذف می شوند. ادامه می دهید؟
                </rsuite.Modal.Body>
                <rsuite.Modal.Footer>
                    <rsuite.Button appearance="primary" color="red" onClick={DoDelete}>حذف</rsuite.Button>
                    <rsuite.Button appearance="default" onClick={() => setShowDelete(false)}>بستن</rsuite.Button>
                </rsuite.Modal.Footer>
            </rsuite.Modal>

        </Shared>
    );
}

export default Index;
